
import { extractMetaProperties } from "../Layers/util";
import { createFlatObjectFromLayerWithMetaObject, createLayerWithMetaObjectFromFlatObject } from "../util";

export const formatCheck2Backend = (data) => {
    const fields = [
        "check_id",
        "user_id",
        "created",
        "updated",
        "is_pre_ripening",
        "like",
        "box_size",
        "desired_stage",
        "is_maxi_check",
        "maxi_exit",
        "maxi_process_name",
        "location",
        "is_manual",
        "feedback",
        "next_action",
        "status_check",
        "user_agreement",
        "user_avg_pressure",
        "user_split",
        "pallet_status",
        "size",
        "size_category",
        "flag",
        "tracebility",
        "weight_kg",
        "pallet_integrety",
        "box_integrity",
        "temperature",
        "shelf_life_type",
        "box_net_weight",
        "movement",
        "rejection_satisfied",
        "flag_external_defects",
        "flag_internal_defects",
        "flag_average_brix",
        "flag_maturity_dist",
        "flag_average_maturity",
        "flag_average_dry_matter",
        "flag_julian_code",
        "flag_pressure_homogeneity",
        "flag_ripening_speed",
        "flag_defects",
        "flag_pressure",
        "flag_ripeness",
        "flag_dm_brix",
        "flag_homogeneity",
        "internal_defected_fruit",
        "external_defected_fruit",
        "total_defected_fruit",
        "regression_ratio",
        "regression_msle",
        "tenant_id",
        "layer_id",
        "location_id",
        "session_id",
        "avocados", // readonly field
        "images", // readonly field
        "has_pressurecalibration", // readonly field
        "defects", // readonly field
        "defect_list", // readonly field
    ];
    return createLayerWithMetaObjectFromFlatObject(data, fields);
};
// * format meta array to flat object to make our lives easier
export const formatCheck2Frontend = (backendCheck) => {
    let check = createFlatObjectFromLayerWithMetaObject(backendCheck);

    // * Make a flat object from the defects array (defects logged on check, but not on fruit. aka visual check), but keep the orginal list to use in the pdf reports
    if (Array.isArray(check.avocados)) {
        const avocados = extractMetaProperties(check.avocados);
        check = { ...check, avocados };
    }

    if (Array.isArray(check.defects)) {
        const defect_list = check.defects;
        const defects = check.defects.reduce((acc, defect) => ({ ...acc, [defect.defect_id]: defect.frequency }), {});
        const visual_defects = defect_list.reduce((acc, defect) => acc + defect.frequency, 0);
        return { ...check, defects, defect_list, visual_defects };
    }
    return check;
};


// If requirements get more specific, then we should use this method to count total defects per position and severity
// export const countTotalDefectsPerPositionAndSeverity = (tenantDefectDefinitions, check_defects) => tenantDefectDefinitions.reduce((acc, defect) => {
//     const key_combined = `total_defects_${defect.position}_${defect.severity}`;
//     const delta = check_defects?.[defect.defect_id] || 0;
//     const total_combined = (acc[key_combined] || 0) + delta; // internal_minor / internal_major / internal_unacceptable / external_minor / external_major / external_unacceptable
//     const total_position = (acc[defect.position] || 0) + delta; // internal / external
//     const total_severity = (acc[defect.severity] || 0) + delta; // minor / major / unacceptable
//     const total_defects = (acc.total_defects || 0) + delta;
//     return { ...acc,
//         [key_combined]: total_combined,
//         [`total_defects_${defect.position}`]: total_position,
//         [`total_defects_${defect.severity}`]: total_severity,
//         [`total_defects_${defect.position}_${defect.severity}`]: total_combined,
//         total_defects,
//     };
// }, {});

